import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ArticulosCreateComponent } from './articulos-create/articulos-create.component';
import { ArticulosListComponent } from './articulos-list/articulos-list.component';
import { ArticulosProveedorListComponent } from './articulos-proveedor-list/articulos-proveedor-list.component';

const routes: Routes = [

    { path: '', component: ArticulosListComponent  },
    { path: 'edit/:id', component: ArticulosCreateComponent },
    { path: 'crear', component: ArticulosCreateComponent }, 
    { path: 'articulos_proveedor', component: ArticulosProveedorListComponent } 
    
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AppArticulosRoutingModule {}
